import * as React from 'react';
import { useContext } from 'react';
import { useTheme } from '../theme';
import cn from 'classnames';
import { InfoMessageTypeEnum } from '@websky/graphql';
import Notification from '../BaseComponents/Notification';
import { InfoMessagesContext } from './context';
import { filterMessageByPosition } from './utils';
import PromoNotification from '../Notification/components/PromoNotification/PromoNotification';
import { BUSINESS_RULES_CHECKBOXES_CODES } from '@shared/config/constants/app';
import { reachGoal, InfoMessageGoal } from '../analytics';
const STATUS_MAP = {
    [InfoMessageTypeEnum.Warning]: 'error',
    [InfoMessageTypeEnum.Promo]: 'note',
    [InfoMessageTypeEnum.Info]: 'warning',
    [InfoMessageTypeEnum.SubscriptionSaving]: 'subscription',
    [InfoMessageTypeEnum.HtmlContent]: 'note'
};
const ALWAYS_FILTER_CODES = [...BUSINESS_RULES_CHECKBOXES_CODES, 'chamomile'];
const InfoMessages = props => {
    var _a, _b, _c;
    const { InfoMessages: theme } = useTheme('InfoMessages');
    const messagesFromContext = (_a = useContext(InfoMessagesContext)) === null || _a === void 0 ? void 0 : _a.messages;
    const messages = (_c = ((_b = props.messages) !== null && _b !== void 0 ? _b : messagesFromContext)) === null || _c === void 0 ? void 0 : _c.filter(message => filterMessageByPosition(props.position, message)).filter(({ code }) => !ALWAYS_FILTER_CODES.includes(code));
    if (!(messages === null || messages === void 0 ? void 0 : messages.length)) {
        return null;
    }
    const renderNotification = (message, index) => {
        var _a;
        const itemStyle = props.baseOrder ? { order: props.baseOrder + index } : undefined;
        if (props.searchParameters && message.code === 'recommended' && message.type === 'Promo') {
            return (React.createElement(PromoNotification, { searchParams: props.searchParameters, key: index, title: message.title, image: message.image, status: message.type, infoMessage: message, type: 'context' }));
        }
        const isHtmlContent = message.type === InfoMessageTypeEnum.HtmlContent;
        const renderMessagesWithoutWrapper = props.renderMessagesWithoutWrapper || isHtmlContent;
        return (React.createElement(Notification, { renderMessagesWithoutWrapper: renderMessagesWithoutWrapper, key: index, title: message.title, image: message.image, text: message.text, code: message.code, asHtml: isHtmlContent, status: (_a = STATUS_MAP[message.type]) !== null && _a !== void 0 ? _a : 'note', type: "global", className: cn(theme.notification, props.itemClassName, {
                [props.itemHtmlClassName]: isHtmlContent,
                [theme.notification__html]: isHtmlContent
            }), contentClassName: cn(theme.notification__content, props.contentClassName), htmlClassName: props.htmlClassName, style: itemStyle }));
    };
    React.useLayoutEffect(() => {
        const transfer = document === null || document === void 0 ? void 0 : document.querySelector('div.BookingAncillaries__root_transfer');
        if (!transfer) {
            return () => { };
        }
        reachGoal(InfoMessageGoal.PurchaseTransferShow);
        const button = document === null || document === void 0 ? void 0 : document.querySelector('div.BookingAncillaries__root_transfer button.BookingAncillaries__button');
        if (!button) {
            return () => { };
        }
        const buttonHandler = () => {
            reachGoal(InfoMessageGoal.PurchaseTransferClick);
        };
        if (button) {
            button.addEventListener('click', buttonHandler);
        }
        return () => {
            button.removeEventListener('click', buttonHandler);
        };
    }, []);
    if (props.renderMessagesWithoutWrapper) {
        return React.createElement(React.Fragment, null, messages.map(renderNotification));
    }
    return (React.createElement("div", { className: cn(theme.container, props.className) },
        React.createElement("div", { className: cn(theme.notifications, props.notificationsClassName) }, messages.map(renderNotification))));
};
export default InfoMessages;
